/** One key per send. The same text, mime, and size is the same send. */
export function createSendIdempotencyKey(
  text: string,
  file?: { mimeType?: string; data?: string } | null
): string {
  const body = text.trim()
  const mime = file?.mimeType ?? ''
  const size = file?.data?.length ?? 0
  return `${body}|${mime}|${size}`
}

/**
 * Drop a double-click, a second Enter, or a retry that is already in flight.
 * A later distinct send, including the same text after the in-flight one finished, is kept.
 */
export function shouldAcceptSend(input: {
  key: string
  now: number
  last?: { key: string; at: number } | null
  inFlight: ReadonlySet<string>
  windowMs?: number
}): boolean {
  if (!input.key.trim()) return false
  if (input.inFlight.has(input.key)) return false
  const windowMs = input.windowMs ?? 800
  if (input.last && input.last.key === input.key && input.now - input.last.at < windowMs) return false
  return true
}

/** Research in flight locks send. A timeout or an error releases it. */
export function researchBlocksSend(input: {
  isResearching: boolean
  preflightFailed?: boolean | undefined
  preflightTimedOut?: boolean | undefined
}): boolean {
  return input.isResearching && !input.preflightFailed && !input.preflightTimedOut
}
